/* eslint-disable no-console */
import {DownloadOutlined} from '@ant-design/icons';
import {Button, Flex} from 'antd';
import React from 'react';

// import {filterSelectOptions} from '../../../components/Forms/Utils/commonFunctions';
import {GenerateReportButtonText} from '../../../constants/Common';
import Year from '../../../shared/Year';
// import useCompanyStore from '../../../store/companyStore/companyDetailsStore';
// import useJSONStore from '../../../store/StaticJson/jsonStore';
import {reportDownload} from '../constants/commonConstants';

const YearAndCountryFilter: React.FC<{
  setSelectedYear: React.Dispatch<React.SetStateAction<string>>;
  setSelCountry: React.Dispatch<React.SetStateAction<number | undefined>>;
  setSelState: React.Dispatch<React.SetStateAction<number | undefined>>;
  selCountry: number | undefined;
  selState: number | undefined;
  showLeased?: boolean | undefined;
  selectedYear: string;
  isDisabled?: boolean;
}> = ({
  setSelectedYear,
  // setSelCountry,
  // setSelState,
  // selCountry,
  // selState,
  // showLeased = undefined,
  // selectedYear,
  isDisabled = false
}) => {
  // const {country, states} = useJSONStore.getState();
  // const {facilityDetails} = useCompanyStore.getState();

  return (
    <Flex gap="1rem" style={{width: '50%'}}>
      <Year
        setSelectedYear={setSelectedYear}
        isESG
        noPadding
        noBottomMargin
        colSpan={24}
        isDisabled={isDisabled}
      />
      {/* <Select
        showSearch
        allowClear
        className="select"
        placeholder={'By Country'}
        filterOption={filterSelectOptions}
        options={country.filter((item) => {
          if (showLeased === undefined) {
            return facilityDetails?.[selectedYear]?.some((subItem: any) => {
              return subItem.country === item.value;
            });
          } else {
            return facilityDetails?.[selectedYear]?.some((subItem: any) => {
              return (
                subItem.country === item.value &&
                subItem.isLeased === showLeased
              );
            });
          }
        })}
        disabled={isDisabled}
        onChange={(e) => {
          setSelCountry(e);
          setSelState(undefined);
        }}
        style={{width: '60%'}}
      />
      <Select
        showSearch
        allowClear
        className="select"
        placeholder={'By State'}
        value={selState}
        filterOption={filterSelectOptions}
        disabled={isDisabled}
        options={
          states.filter((item) => {
            if (showLeased === undefined) {
              return (
                item.country_id === selCountry &&
                facilityDetails?.[selectedYear]?.some((subItem: any) => {
                  return subItem.state === item.value;
                })
              );
            } else {
              return (
                item.country_id === selCountry &&
                facilityDetails?.[selectedYear]?.some((subItem: any) => {
                  return (
                    subItem.state === item.value &&
                    subItem.isLeased === showLeased
                  );
                })
              );
            }
          }) ?? []
        }
        onChange={(e) => {
          setSelState(e);
        }}
        style={{width: '60%'}}
      /> */}
      {false && (
        <Button
          type="default"
          icon={<DownloadOutlined />}
          style={{marginBottom: '10px'}}
          href={reportDownload}
          target="_blank"
          download
        >
          {GenerateReportButtonText()}
        </Button>
      )}
    </Flex>
  );
};

export default YearAndCountryFilter;
